import { FormFieldTypes } from 'common/enums';
import { FormFieldModel } from 'common/interfaces';
import { LeasingContractFields } from '../unfolded-task/components/buttons-for-lease-extension/enums';

export const leaseExtensionOfferFormFields: FormFieldModel[] = [
  {
    name: 'offerFiles',
    type: FormFieldTypes.File,
    defaultValue: [],
    dropzoneOptions: {
      accept: ['.pdf', '.png', '.jpg', '.jpeg', '.heic'],
      maxSize: 5242900,
      multiple: true
    },
    hideError: true,
    validation: {
      required: 'Bitte auswählen'
    }
  },
  {
    name: LeasingContractFields.Comment,
    type: FormFieldTypes.TextArea,
    defaultValue: '',
    label: 'Kommentare',
    validation: {
      maxLength: {
        value: 700,
        message: 'Die maximale Anzahl der verfügbaren Zeichen beträgt 700 Zeichen'
      }
    }
  }
];
